import React,{useLayoutEffect,useRef, useState} from 'react'
import { View ,StyleSheet,Text,Dimensions,TouchableOpacity,Animated} from 'react-native'
import { widthPercentageToDP as wp, heightPercentageToDP as hp, scaleSize } from '../../../../Utils/responsive';
import NoSinsToken from "../../../../assets/svg/Token-NoSins.svg";
import PeoplePlanetToken from "../../../../assets/svg/Token-PeoplePlanet.svg";
import PlanetToken from "../../../../assets/svg/Token-Planet.svg";
import PlanetOverReturnsToken from "../../../../assets/svg/Token-PlanetOverReturns.svg";
import ReturnsOverPlanetToken from "../../../../assets/svg/Token-ReturnsOverPlanet.svg";
import PeopleOverReturnsToken from "../../../../assets/svg/Token-PeopleOverReturns.svg";
import ReturnsOverPeopleToken from "../../../../assets/svg/Token-ReturnsOverPeople.svg";
import BothOverReturnsToken from "../../../../assets/svg/Token-BothOverReturns.svg";
import ReturnsOverBothToken from "../../../../assets/svg/Token-ReturnsOverBoth.svg";
import PositiveImpactToken from "../../../../assets/svg/Token-PositiveImpact.svg";
import PeopleToken from "../../../../assets/svg/Token-People.svg";
import CarbonNeutralToken from "../../../../assets/svg/Token-CarbonNeutral.svg";
import AllToken from "../../../../assets/svg/Token-All.svg";
const actualWidth = Dimensions.get("screen").width;
// Use the actual viewport height (window), not the physical monitor (screen) —
// the latter does not change when the browser window is resized, so the
// short-screen layout adjustments below would never fire in a small window.
const actualHeight = Dimensions.get("window").height;

let deviceWidth = Dimensions.get("window").width;
let deviceHeigth = Dimensions.get("window").height;

const isIpad =
  navigator.userAgent.match(/Mac/) &&
  navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 2;

const DragBalls = (props) => {
  return (
    <>
      {props.iconKey === "planet" && (
        <img
          alt=""
          src={PlanetToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "people" && (
        <img
          alt=""
          src={PeopleToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "planetandpeople" && (
        <img
          alt=""
          src={PeoplePlanetToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "planetmoney" && (
        <img
          alt=""
          src={PlanetOverReturnsToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "moneyplanet" && (
        <img
          alt=""
          src={ReturnsOverPlanetToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "positiveonly" && (
        <img
          alt=""
          src={PositiveImpactToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "carbonneutral" && (
        <img
          alt=""
          src={CarbonNeutralToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "screen" && (
        <img
          alt=""
          src={NoSinsToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "all" && (
        <img
          alt=""
          src={AllToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "peoplemoney" && (
        <img
          alt=""
          src={PeopleOverReturnsToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "moneypeople" && (
        <img
          alt=""
          src={ReturnsOverPeopleToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "bothmoney" && (
        <img
          alt=""
          src={BothOverReturnsToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "moneyboth" && (
        <img
          alt=""
          src={ReturnsOverBothToken}
          style={{
            width: scaleSize(actualWidth > 400 ? 62 : 31),
            height: scaleSize(actualWidth > 400 ? 62 : 31),
            objectFit: "contain",
          }}
        />
      )}
    </>
  );
};

export const ConfirmationText = (props) => {
  const [height, setHeight] = useState(deviceHeigth);
  const [width, setWidth] = useState(deviceWidth);

  Dimensions.addEventListener("change", (e) => {
    deviceHeigth = e.window.height;
    deviceWidth = e.window.width;
    setHeight(deviceHeigth);
    setWidth(deviceWidth);
  });

  const animation = useRef(new Animated.Value(0)).current;
  const completefuntion = () => {
    props.selectAnswerHandler(
      props.moduleObject.moduleid,
      props.moduleObject.questions[props.moduleIndex].qid,
      props.answerId
    );
    props.resultContext.setModuleCompletedAtTime(props.moduleObject.moduleid);
    props.history.push("/");
  };
  const resetfunction = () => {
    props.pageOne();
    props.pageTwo();
    props.pageThree();
    props.setCompeleteTask(false);
    props.setModuleIndex(0);
    props.resultContext.resetModuleResult(props.moduleObject.moduleid);
  };

  useLayoutEffect(() => {
    props.setDragOpacity(true);
    Animated.timing(animation, {
      toValue: 1,
      duration: 500,
    }).start();
  }, []);

  return (
    <Animated.View
      style={[
        styles.container,
        {
          opacity: animation,
          minHeight:
            isIpad && width > height
              ? "64%"
              : actualWidth > 1000
              ? actualHeight < 900
                ? "50%"
                : "60%"
              : actualWidth > 400
              ? "70%"
              : "60%",
          height: "auto",
        },
      ]}
    >
      <Text style={styles.heading}>{props.metadata.resultlabel}</Text>
      <View style={styles.Line} />
      {props.metadata.confirmationtext.map((data, index) => {
        return (
          <View key={index} style={{ alignItems: "center" }}>
            <Text style={styles.subHeading}>{data.text}</Text>
            <View
              style={{
                marginBottom:
                  actualWidth > 1000
                    ? actualHeight < 900
                      ? hp("1%")
                      : hp("3%")
                    : actualWidth > 330
                    ? hp("3%")
                    : hp("1.5%"),
              }}
            >
              <DragBalls iconKey={data.iconkey} />
            </View>
          </View>
        );
      })}
      {actualWidth > 550 && <View style={styles.Line} />}
      <TouchableOpacity style={styles.button} onPress={completefuntion}>
        <Text style={styles.buttontext}>{props.metadata.buttontext}</Text>
      </TouchableOpacity>
      <TouchableOpacity style={styles.goBack} onPress={resetfunction}>
        <Text style={styles.goBackText}>
          I've changed my mind (start again)
        </Text>
      </TouchableOpacity>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "transparent",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: "100%",
    marginBottom:
      actualWidth > 700
        ? isIpad
          ? 10
          : actualHeight < 900
          ? 8
          : 30
        : hp("1%"),
    minHeight:
      actualWidth > 1000
        ? actualHeight < 900
          ? "50%"
          : "60%"
        : actualWidth > 400
        ? "70%"
        : "60%",
  },
  heading: {
    fontSize: scaleSize(actualWidth > 600 ? 48 : actualWidth > 400 ? 32 : 16),
    textAlign: "center",
    color: "var(--text-color-default)",
    marginBottom:
      actualWidth > 1000
        ? actualHeight < 900
          ? hp("1%")
          : hp("3%")
        : actualWidth > 330
        ? hp("2%")
        : hp("1%"),
    fontWeight: "var(--font-weight-light)",
    letterSpacing:
      actualWidth > 1000
        ? actualHeight < 900
          ? 3.2
          : 4.8
        : actualWidth > 400
        ? 3.2
        : 1.6,
  },
  Line: {
    width:
      actualWidth > 1000
        ? wp("35%")
        : actualWidth > 400
        ? wp("45%")
        : wp("55%"),
    height: 1,
    backgroundColor: "#d4d4d4",
    marginBottom:
      actualWidth > 1000
        ? actualHeight < 900
          ? hp("1%")
          : hp("3%")
        : actualWidth > 330
        ? hp("2%")
        : hp("1%"),
  },
  subHeading: {
    fontSize: scaleSize(actualWidth > 400 ? 20 : 12),
    color: "var(--text-color-default)",
    width: actualWidth > 700 ? "100%" : actualWidth > 400 ? "95%" : "95%",
    letterSpacing: actualWidth > 1000 ? 2 : actualWidth > 400 ? 2 : 1.2,
    fontWeight: "var(--font-weight-light)",
    textAlign: "center",
    marginBottom:
      actualWidth > 1000
        ? actualHeight < 900
          ? hp("1%")
          : hp("1%")
        : hp("1%"),
  },
  button: {
    backgroundColor: "var(--text-color-default)",
    width: actualWidth > 1000 ? 296 : actualWidth > 400 ? 296 : 230,
    height: 48,
    marginBottom:
      actualWidth > 1000
        ? actualHeight < 900
          ? hp("1%")
          : hp("3%")
        : hp("1%"),
    justifyContent: "center",
    borderRadius: 2,
    elevation: 2,
    shadowColor: "rgba(0, 0, 0, 0.15)",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 2,
  },
  buttontext: {
    color: "#ffffff",
    fontWeight: "var(--font-weight-bold)",
    fontSize: actualWidth > 400 ? 16 : 12,
    textAlign: "center",
    letterSpacing: actualWidth > 400 ? 1.6 : 1.2,
    textTransform: "uppercase",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 1 },
    padding: 5,
  },
  goBack: {
    backgroundColor: "transparent",
    width: actualWidth > 1000 ? 416 : actualWidth > 400 ? 320 : 210,
    height: 48,
    marginBottom:
      actualWidth > 1000
        ? actualHeight < 900
          ? hp("1.5%")
          : hp("3%")
        : actualWidth > 400 && actualWidth < 500
        ? hp("0%")
        : hp("3%"),
    justifyContent: "center",
  },
  goBackText: {
    color: "var(--text-color-default)",
    fontWeight: "var(--font-weight-bold)",
    fontSize: actualWidth > 1000 ? 16 : actualWidth > 400 ? 12 : 12,
    textAlign: "center",
    letterSpacing: actualWidth > 1000 ? 1.6 : actualWidth > 400 ? 1.2 : 1.2,
    textTransform: "uppercase",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 1 },
    padding: 5,
  },
});